import { render, staticRenderFns } from "./upload-material.vue?vue&type=template&id=4718dc67&scoped=true&"
import script from "./upload-material.vue?vue&type=script&lang=js&"
export * from "./upload-material.vue?vue&type=script&lang=js&"
import style0 from "./upload-material.vue?vue&type=style&index=0&id=4718dc67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718dc67",
  null
  
)

component.options.__file = "upload-material.vue"
export default component.exports